import { defineStore } from 'pinia';
import storage from "@/utils/storage.js";

const storeId = storage.get('storeId');
export const useBusinessMallStore = defineStore('businessMall', {
	state: () => ({
		storeId: storeId || null,
		isStorePlatform: storeId ? true : false,
	}),
	actions:{
		setStoreId(id){
			this.storeId = id;
			this.isStorePlatform = true;
			storage.set('storeId', id);
		}
	}
})